import sha1 from "simple-sha1";

export function thumbFromUrl(width: number, height: number, image: string, format: "webp" | null = "webp"): string {
	let newPath = image;
	if (format !== null) {
		newPath += `.${format}`;
	}
	const imageUrl = new URL(image);
	const url = new URL(newPath, imageUrl.origin);
	url.pathname = `/${width}x${height}${url.pathname}`;
	return `${url.toString()}?hash=${sha1.sync(url.pathname.replace("/", ""))}`;
}
